import { render, staticRenderFns } from "./actiVity.vue?vue&type=template&id=51063a80&scoped=true&"
import script from "./actiVity.vue?vue&type=script&lang=js&"
export * from "./actiVity.vue?vue&type=script&lang=js&"
import style0 from "./actiVity.vue?vue&type=style&index=0&id=51063a80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51063a80",
  null
  
)

export default component.exports